'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadMsaAliasToId = exports.getMsaAliasToId = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _factory = require('./factory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _makeDynamicDataLoade = (0, _factory.makeDynamicDataLoader)('msas', function (set, client) {
  return client.msas.getList({ include_all: 1 }).then(function (_ref) {
    var msas = _ref.msas;
    return set(msas.reduce(function (acc, msa) {
      return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, msa.alias, msa.id));
    }, {}));
  });
}),
    getMsaAliasToId = _makeDynamicDataLoade.get,
    loadMsaAliasToId = _makeDynamicDataLoade.load;

exports.getMsaAliasToId = getMsaAliasToId;
exports.loadMsaAliasToId = loadMsaAliasToId;